import { API } from '@enrich/shared-lib';

export const contactsQuery = async (options = {}) => {
    const graduationOptions = options.graduationDates.map(
        (date) => `
        {
            graduationSemester: {eq: "${date.value.semester}"},
            graduationYear: {eq: ${date.value.year}},
        }
    `,
    );
    const graduationQueryClause = graduationOptions
        ? `{or: [${graduationOptions}]},`
        : '';
    const hometownOptions = options.hometowns.map(
        (hometown) => `{
            hometown: { contains: "${hometown}" }
        }`,
    );
    const hometownQueryClause = hometownOptions
        ? `{or: [${hometownOptions}]},`
        : '';

    const query = `query myQuery(
        $coaches: [ID],
        $companies: [ID],
        $enrichProgramStatuses: [String],
        $ethnicities: [ID],
        $gpaMinimum: Float,
        $genders: [String],
        $degreeTypes: [String],
        $jobs: [ID],
        $majors: [ID],
        $page: Int,
        $pageSize: Int,
        $preferredIndustries: [ID],
        $resumeStatuses: [String],
        $relocationPreferences: [ID],
        $schools: [ID],
        $technicalSkills: [ID],
        $preferredJobFunctions: [ID]
        $communicationLevels: [Int]
        $sort: [String]
    ) {
        contacts(filters: {
            and: [
                {candidacies: {job:
                    {or: [{id: {in: $jobs}}, {company: {id: {in: $companies}}}] },
                }},
                {coach: {id: {in: $coaches}}},
                {enrichProgramStatus: {in: $enrichProgramStatuses}},
                {ethnicities: {id: {in: $ethnicities}}},
                {gender: {in: $genders}},
                {degreeType: {in: $degreeTypes}},
                {gpa: {gte: $gpaMinimum}},
                ${graduationQueryClause}
                ${hometownQueryClause}
                {majors: {id: {in: $majors}}},
                {preferredLocations: {id: {in: $relocationPreferences}}},
                {preferredIndustries: {id: {in: $preferredIndustries}}},
                {resumeStatus: {in: $resumeStatuses}},
                {school: {id: {in: $schools}}},
                {preferredJobFunctions: {id: {in: $preferredJobFunctions}}},
                {communicationLevel: {in: $communicationLevels}},
                {technicalSkills: {id: {in: $technicalSkills}}}
            ]
        }, pagination: {page: $page, pageSize: $pageSize}, sort: $sort) {
            data {
                id
                attributes {
                    email
                    firstName
                    lastName
                    graduationSemester
                    graduationYear
                    communicationLevel
                    resumeStatus
                    candidacies(filters: {job: {id: {in: $jobs}}}) {
                        data {
                            id
                            attributes {
                                status
                                job {
                                    data {
                                        id
                                    }
                                }
                            }
                        }
                    }
                    majors {
                        data {
                            attributes {
                                name
                            }
                        }
                    }
                    school {
                        data {
                            attributes {
                                name
                            }
                        }
                    }
                }
            }
            meta {
                pagination {
                    page
                    pageCount
                    pageSize
                    total
                }
            }
        }
    }`;

    const variables = Object.fromEntries(
        // we do this to remove empty or falsey filter options
        Object.entries(options).filter((entry) => {
            return Array.isArray(entry[1])
                ? entry[1].length > 0 // if entry value is an array, return entry if array is not empty
                : Boolean(entry[1]); // if entry value is not an array, return entry if value is truthy
        }),
    );

    try {
        const graphqlResponse = await API.post('graphql', {
            query,
            variables,
        });

        const contactResults = graphqlResponse.data.data.contacts.data.map(
            (contact) => {
                return {
                    id: contact.id,
                    ...contact.attributes,
                };
            },
        );

        return {
            contacts: contactResults,
            pagination: graphqlResponse.data.data.contacts.meta.pagination,
        };
    } catch (error) {
        console.log(error);
        return { contacts: [] };
    }
};
